import type { CuiLookupCompany } from '@pcrm/fe/ui-kit';
import { formatAnafAddress } from '../companies/anaf.api';
import { EMPTY_PARTNER, type PartnerInput } from './partners.api';

/**
 * Răspunsul ANAF → formularul de partener.
 *
 * **Se ia tot** (fondatorul, 2026-09-17: „trebuie la parteneri salvate toate datele date de
 * ANAF"), spre deosebire de firmele grupului, unde se rețin trei câmpuri. Motivul e al
 * contabilității: sediul și starea TVA sunt ce-i trebuie ca să înregistreze un act, iar dacă
 * nu stau pe partener se caută din nou la ANAF de fiecare dată.
 *
 * Funcție pură, într-un fișier al ei, pentru că o folosesc **două ecrane**: sertarul din
 * Conta → Parteneri și formularul de încărcare a unui document (#133). A doua copie ar fi
 * divergat la primul câmp adăugat, iar diferența s-ar fi văzut ca doi parteneri cu date
 * diferite pentru același CUI.
 *
 * ⚠️ **Adresa se lipește într-o linie**, ca la firme: ANAF o ține pe patru câmpuri, iar
 * `legal_address` e unul singur. Localitatea și județul rămân **și** pe coloanele lor — sunt
 * ce se filtrează, iar dintr-o linie lipită nu se mai pot scoate.
 */
export function partnerInputFromAnaf(found: CuiLookupCompany): PartnerInput {
  return {
    ...EMPTY_PARTNER,
    name: found.name,
    // CUI-ul normalizat de server: fără `RO`, fără spații. E forma în care se caută mai târziu.
    taxCode: found.cui,
    tradeRegisterNo: found.tradeRegisterNo ?? '',
    legalAddress: formatAnafAddress(found.address),
    city: found.address.city ?? '',
    county: found.address.county ?? '',
    postalCode: found.address.postalCode ?? '',
    phone: found.phone ?? '',
    vatPayer: found.vatPayer,
    vatOnCollection: found.vatOnCollection,
    anafStatus: found.status,
    anafStatusText: found.statusText ?? '',
    // Momentul citirii, cum l-a produs serverul. ⚠️ Nu e `updated_at`: spune cât de veche e
    // starea TVA, nu când a fost atins rândul ultima dată.
    anafCheckedAt: found.checkedAt,
  };
}
